import React from 'react';
import { useInView } from '../useInView';
import { FaClipboardList, FaMoneyBillWave, FaPalette, FaShippingFast } from 'react-icons/fa';

const STEPS = [
  { n: '01', icon: <FaClipboardList />, title: 'Share Your Needs', desc: 'Tell us the bag type, size, quantity & your logo/design via WhatsApp or call.' },
  { n: '02', icon: <FaMoneyBillWave />, title: 'Get Best Price', desc: 'Factory-direct quote in minutes — no hidden charges, best rate guaranteed.' },
  { n: '03', icon: <FaPalette />, title: 'Print & Pack', desc: 'Manufactured with vibrant printing and quality-checked before dispatch.' },
  { n: '04', icon: <FaShippingFast />, title: 'Fastest Delivery', desc: 'Fastest delivery anywhere in India, fully tracked.' },
];

export default function Process() {
  const [ref, v] = useInView();

  return (
    <>
      <style>{`
        .step-box:hover { border-color: rgba(200,137,58,0.4) !important; background: rgba(200,137,58,0.06) !important; }
        @keyframes lineGrow { from{width:0} to{width:100%} }
        @media(max-width:900px){
          .steps-row { flex-direction:column!important; align-items:stretch!important; gap: 12px!important; }
          .step-box { width: 100%!important; }
          .step-connector{display:none!important;}
        }
        @media(max-width:768px){ .steps-row { flex-direction:column!important; align-items:stretch!important; } .step-connector{display:none!important;} }
        @media(max-width:600px){
          .process-title { font-size:clamp(28px,8vw,40px)!important; }
          .process-sub { font-size:15px !important; line-height:1.6 !important; }
          .step-box { padding:24px 20px !important; }
          .step-num { font-size:24px !important; }
        }
      `}</style>
      <section style={s.section}>
        <div style={s.container}>
          <div ref={ref} style={{ ...s.header, opacity: v ? 1 : 0, transform: v ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}>
            <div style={s.tagLine}><span style={s.dash} /><span style={s.tag}>HOW IT WORKS</span><span style={s.dash} /></div>
            <h2 className="process-title" style={s.title}>Simple 4-Step Process</h2>
            <p className="process-sub" style={s.sub}>From your idea to finished bags — fast, easy, professional.</p>
          </div>

          <div className="steps-row" style={s.row}>
            {STEPS.map((step, i) => (
              <React.Fragment key={step.n}>
                <div
                  className="step-box"
                  style={{
                    ...s.box,
                    opacity: v ? 1 : 0,
                    transform: v ? 'none' : 'translateY(28px)',
                    transition: `all 0.6s ease ${i * 0.12}s`,
                  }}
                >
                  <div style={s.stepNum}>{step.n}</div>
                  <div style={s.iconWrap}>{step.icon}</div>
                  <div style={s.stepTitle}>{step.title}</div>
                  <div style={s.stepDesc}>{step.desc}</div>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="step-connector" style={s.connector}>
                    <div style={{ ...s.connLine, width: v ? '100%' : '0%', transition: `width 0.8s ease ${i * 0.2 + 0.4}s` }} />
                    <span style={s.connArrow}>›</span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* CTA bar */}
          <div style={{ ...s.ctaBar, opacity: v ? 1 : 0, transition: 'opacity 0.7s ease 0.5s' }}>
            <span style={s.ctaText}>Ready to order? Contact us now and get your quote in minutes!</span>
            <button style={s.ctaBtn} onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Start Your Order →
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

const s = {
  section: {
    background: 'linear-gradient(180deg, #0d0d0d 0%, #0a0a0a 100%)',
    padding: '120px 24px', position: 'relative',
    borderTop: '1px solid rgba(200,137,58,0.1)',
    borderBottom: '1px solid rgba(200,137,58,0.1)',
  },
  container: { maxWidth: 1280, margin: '0 auto' },
  header: { textAlign: 'center', marginBottom: 64 },
  tagLine: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 16 },
  dash: { width: 40, height: 1, background: 'rgba(200,137,58,0.5)', display: 'inline-block' },
  tag: { fontSize: 11, letterSpacing: 4, color: '#c8893a', fontWeight: 700 },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(30px,4vw,50px)', fontWeight: 700,
    color: '#f0ede6', lineHeight: 1.15, marginBottom: 12,
  },
  sub: { fontSize: 15, color: 'rgba(240,237,230,0.5)' },
  row: { display: 'flex', alignItems: 'flex-start', gap: 0, marginBottom: 56 },
  box: {
    flex: 1, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 20, padding: '32px 24px', textAlign: 'center',
    transition: 'all 0.25s ease',
  },
  stepNum: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 52, fontWeight: 700,
    color: 'rgba(200,137,58,0.2)', lineHeight: 1, marginBottom: 16,
  },
  iconWrap: { fontSize: 36, marginBottom: 14 },
  stepTitle: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 700,
    color: '#f0ede6', marginBottom: 10,
  },
  stepDesc: { fontSize: 13.5, color: 'rgba(240,237,230,0.5)', lineHeight: 1.7 },
  connector: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    width: 48, flexShrink: 0, paddingTop: 72, position: 'relative',
  },
  connLine: {
    height: 1, background: 'linear-gradient(90deg, rgba(200,137,58,0.6), rgba(200,137,58,0.2))',
  },
  connArrow: { fontSize: 24, color: '#c8893a', position: 'absolute', right: -4, top: 60 },
  ctaBar: {
    background: 'rgba(200,137,58,0.08)', border: '1px solid rgba(200,137,58,0.2)',
    borderRadius: 16, padding: '24px 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16,
  },
  ctaText: { fontSize: 16, fontWeight: 600, color: 'rgba(240,237,230,0.8)' },
  ctaBtn: {
    background: 'linear-gradient(135deg,#c8893a,#e8a84a)', color: '#0a0a0a',
    border: 'none', borderRadius: 10, padding: '13px 28px',
    fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 14,
    cursor: 'pointer', letterSpacing: 0.3,
    boxShadow: '0 6px 24px rgba(200,137,58,0.35)',
  },
};
